import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://hmuoqixfwdqjdlhfquuj.supabase.co'
const supabaseAnonKey = 'sb_publishable_1bQYto1IlvQbTa6ACVK3Ag_iV03rZ3e'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)